__turbopack_context__.v({
  "left": "ProjectLogos-module__uOmdDG__left",
  "right": "ProjectLogos-module__uOmdDG__right",
});
